export const APPROVED_SALES_LISTING = "APPROVED_SALES_LISTING";
export const LEDGER_LISTING = "LEDGER_LISTING";
export const GET_SITE_CHALLAN = "GET_SITE_CHALLAN";
